/*
 * Such-Fenster (snippets/search-overlay.liquid, Figma "Search Component" 425:13635).
 * - Header-Link "Search" oeffnet das Fenster (ohne JavaScript: normale Seite /search).
 * - Tippen laedt nach 200 ms die Vorschau per Section Rendering (sections/predictive-search.liquid).
 * - Escape, Schliessen-Knopf und Klick auf die Abdunklung schliessen; der Fokus geht zurueck an den Link.
 * - Bilder der Vorschau: neue Ergebnisse werden erst eingesetzt, wenn ihre Bilder geladen sind (hoechstens
 *   WAIT_IMAGES ms), danach blenden noch fehlende Bilder weich ein. Kein Flackern beim Tippen.
 * - Ein-/Ausblenden (Alex, Pastel #46, 25.09.: "the search bar should animate in"): Klasse is-visible startet die
 *   CSS-Uebergaenge (snippets/search-overlay.liquid); beim Schliessen erst ausblenden, dann dialog.close().
 *   Bei prefers-reduced-motion: reduce sofort.
 */
(function () {
  if (window.__skogSearchOverlay) return;
  window.__skogSearchOverlay = true;

  var DELAY = 200;
  var WAIT_IMAGES = 400;
  // je Art (Vorschlaege, Produkte) hoechstens 8: Figma "too many results" zeigt 8 Produkte, die Liste scrollt
  var LIMIT = 8;

  function init() {
    var dialog = document.getElementById('SearchOverlay');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var panel = dialog.querySelector('.search-overlay__panel');
    var input = dialog.querySelector('input[name="q"]');
    var results = dialog.querySelector('[data-search-results]');
    var trigger = null;
    var timer = null;
    var controller = null;
    var cache = {};

    function show(nodes) {
      results.replaceChildren.apply(results, nodes);
      var has = results.querySelector('.predictive-search__all') !== null;
      panel.classList.toggle('has-results', has);
    }

    /** Bild weich einblenden: fertig geladene sofort sichtbar, die anderen nach dem Laden. */
    function fade(img) {
      if (img.complete && img.naturalWidth) {
        img.classList.add('is-loaded');
        return;
      }
      img.classList.add('is-pending');
      var done = function () {
        img.classList.remove('is-pending');
        img.classList.add('is-loaded');
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }

    var renderId = 0;
    function render(html) {
      var id = ++renderId;
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      var imgs = Array.prototype.slice.call(tpl.content.querySelectorAll('img'));
      if (!imgs.length) {
        show(Array.prototype.slice.call(tpl.content.childNodes));
        return;
      }
      // Bilder schon im Hintergrund laden (template-Inhalt laedt nichts von selbst)
      var waits = imgs.map(function (img) {
        var probe = new Image();
        if (img.sizes) probe.sizes = img.sizes;
        if (img.srcset) probe.srcset = img.srcset;
        probe.src = img.src;
        return probe.decode ? probe.decode().catch(function () {}) : Promise.resolve();
      });
      var timeout = new Promise(function (resolve) {
        setTimeout(resolve, WAIT_IMAGES);
      });
      Promise.race([Promise.all(waits), timeout]).then(function () {
        if (id !== renderId) return; // inzwischen neuer Begriff
        var nodes = Array.prototype.slice.call(tpl.content.childNodes);
        show(nodes);
        results.querySelectorAll('.predictive-search__thumb img').forEach(fade);
      });
    }

    function clear() {
      if (controller) controller.abort();
      clearTimeout(timer);
      render('');
    }

    function load(terms) {
      if (cache[terms] !== undefined) {
        render(cache[terms]);
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      var url =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') +
        'search/suggest?q=' + encodeURIComponent(terms) +
        '&resources[type]=product,query&resources[limit]=' + LIMIT + '&resources[limit_scope]=each' +
        '&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var node = doc.querySelector('[data-predictive-search]');
          var html = node ? node.outerHTML : '';
          cache[terms] = html;
          // nur anzeigen, wenn der Begriff noch aktuell ist
          if (input.value.trim() === terms) render(html);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') render('');
        });
    }

    var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var closing = null;

    function open(from) {
      trigger = from || null;
      if (closing) {
        clearTimeout(closing);
        closing = null;
      }
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('search-overlay-open');
      // erst im naechsten Frame sichtbar schalten, sonst startet der Uebergang nicht
      void dialog.offsetWidth;
      dialog.classList.add('is-visible');
      input.focus({ preventScroll: true });
      if (input.value.trim()) load(input.value.trim());
    }

    function close() {
      if (!dialog.open || closing) return;
      dialog.classList.remove('is-visible');
      if (noMotion.matches) {
        dialog.close();
        return;
      }
      closing = setTimeout(function () {
        closing = null;
        dialog.close();
      }, 300);
    }

    // Escape: ausblenden statt sofort schliessen
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('search-overlay-open');
      if (trigger) trigger.focus();
    });

    input.addEventListener('input', function () {
      var terms = input.value.trim();
      clearTimeout(timer);
      if (!terms) {
        clear();
        return;
      }
      timer = setTimeout(function () {
        load(terms);
      }, DELAY);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-search-close]')) close();
    });

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-search-open]');
      if (!link || event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      open(link);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
